import React from 'react';
import ClientNotes from './ClientNotes';
import ClientRouteTemplate from './ClientRouteTemplate';

const ClientNotesRoute = (props) => (
  <ClientRouteTemplate 
    {...props}
    Component={ClientNotes}
    componentName="Notes"
  />
);

export default ClientNotesRoute;
